<template>
	<app-header-teleport>
		<div class="flex flex-1 items-center">
			<app-title :title="`${$t('discounts')}`" />
		</div>
	</app-header-teleport>
	<app-section>
		<app-select
			v-if="hasMultipleBusinesses"
			class="mr-1 w-48"
			placeholder="Business"
			:can-deselect="false"
			:options="restaurantOptions"
			@select="filters.restaurantId = $event"
			v-model="filters.restaurantId"
		/>
		<discounts-table :discounts="list" @edit="goToDiscount" :remote-searchable="true" @on-search="onSearch" />
		<app-pagination
			v-if="renderFilters"
			:filters="filters"
			@prevPage="prevPage"
			@nextPage="nextPage"
			@limitChange="changeLimit"
			:loading="loading"
			:has-next-page="list.length === filters.limit"
		/>
	</app-section>
</template>

<script>
	import DiscountsTable from '@/components/discount/DiscountsTable';
	import DiscountsService from '@/services/DiscountService';
	import names from '@/router/names';
	import AppPagination from '@/components/app/AppPagination';
	import AppHeaderTeleport from '@/components/app/AppHeaderTeleport';
	import AppSelect from '@/components/app/AppSelect';
	import { mapGetters } from 'vuex';
	import AppTitle from '@/components/app/AppTitle';

	export default {
		name: 'DiscountList',
		computed: {
			...mapGetters({
				user: 'user',
			}),
			hasMultipleBusinesses() {
				return this.user.restaurants.length > 1;
			},
			restaurantOptions() {
				let array = [];
				this.user.restaurants.forEach((res) =>
					array.push({ label: res.restaurantName, value: res.restaurantID })
				);
				return array;
			},
		},
		components: {
			AppTitle,
			AppSelect,
			AppHeaderTeleport,
			AppPagination,
			DiscountsTable,
		},
		data: () => ({
			list: [],
			businessTypes: [],
			discountStatuses: [
				{ label: 'All', value: -1 },
				{ label: 'Active', value: 1 },
				{ label: 'Inactive', value: 0 },
			],
			filters: {
				limit: 50,
				offset: 0,
			},
			loading: false,
			renderFilters: true,
		}),
		methods: {
			getDiscounts() {
				this.loading = true;
				DiscountsService.getDiscountsList(this.filters)
					.then((res) => (this.list = res))
					.catch((e) => this.$notificationService.error(e))
					.finally(() => {
						this.loading = false;
						this.emitter.emit('isLoading', false);
					});
			},
			onSearch(search) {
				this.filters.userInput = search;
			},
			goToDiscount(discount) {
				this.$router.push({ name: names.DiscountDetails, params: { id: discount.id || 0 } });
			},
			prevPage() {
				this.filters.offset = Math.max(this.filters.offset - this.filters.limit, 0);
			},
			nextPage() {
				this.filters.offset = this.filters.offset + this.filters.limit;
			},
			changeLimit(value) {
				this.filters = {
					...this.filters,
					limit: parseInt(value),
					offset: 0,
				};
			},
		},
		mounted() {
			this.emitter.emit('isLoading', true);
			this.getDiscounts();
		},
		watch: {
			filters: {
				deep: true,
				handler() {
					this.emitter.emit('isLoading', true);
					this.getDiscounts();
				},
			},
		},
	};
</script>
